<template>
    <div id="container" type="vveterans">
        <div class="page page-veterans" v-ga:request="{pageType:'vveterans', state: {}}" v-ga:page="{pageType:'vveterans', glb: glb, state: {}}">
            <mvtHeader />
            <veteransWelcome></veteransWelcome>
            <section>
                <div class="grid fixed sm-grid-cols-1 md-grid-cols-2 veterans-card">
                    <div class="large inline flex vertical bg-default corner outline space-between">
                        <div class="f3 text-bold text-center">Veterans Real Estate Agents</div>
                        <div>Working with a real estate agent who is an expert in Veterans benefits gives you the confidence you need to find your first, or next home.  An experienced Veterans agent will help you navigate the market and take advantage of all the benefits you have available, like a VA home loan.</div>
                        <div>Talk with a Veterans agent today to find your dream home, maximize Veterans benefits, and save time.</div>
                        <a class="btn primary regular w-100" @click="openHotlead" role="button">Meet a Veterans Agent Now</a>
                    </div>
                    <div class="large inline flex vertical bg-default corner outline space-between">
                        <div class="f3 text-bold text-center">VA Home Loans </div>
                        <div>If you or your spouse have served in any branch of the military, you could be eligible to receive the exclusive benefits associated with VA loans.  With a VA loan, you may qualify for $0 down payment, no private mortgage insurance, and limited closing costs.  These benefits get you into your home faster and with less upfront and ongoing cost than a traditional mortgage.</div>
                        <div>Talk to a VA loan specialist today and take the next step in your homebuying journey.</div>
                        <a class="btn primary regular w-100" @click="show3rdPartyForm('veteranshub2', 'veteranshub2', $event)" role="button">Get Pre-Qualified for a VA Loan</a>
                    </div>
                </div>
            </section>
            <section class="inline large">
                <div class="grid gap-3 fixed fixed-max-sm xs-grid-cols-1">
                    <div class="text-center">
                        <h2><b class="f3 text-bold">Frequently Asked Questions</b></h2>
                    </div>
                    <mvtFaq v-if="faqs" :data="faqs"></mvtFaq>
                </div>
            </section>
            <mvtFooter />
        </div>
        <mvtPopSignin />
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-veterans.js"></script>

<style lang="scss">
@use "./page-veterans.scss" as *;
</style>